import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, TextField } from "@mui/material";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EntityNameField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<EditEntityProfileData>();

  return (
    <>
      <Controller
        name="name_ar"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel
              sx={{
                color: "var(--Dark---800, #414141)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("arabicName")}
            </FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("enterArabicName")}
            />
          </FormControl>
        )}
      />
      <Controller
        name="name_en"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel
              sx={{
                color: "var(--Dark---800, #414141)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("englishName")}
            </FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("enterEnglishName")}
            />
          </FormControl>
        )}
      />
    </>
  );
};

export default EntityNameField;
